/**
 * Registers a directive for CMS preference selection within an AngularJS module.
 * @param {object} module - The AngularJS module to which the directive will be registered.
 */
export default function registerCmsPreferenceSelectDirective(module) {
    module.directive('cmsPreferenceSelect', function($compile, $bridges, TaskDataService) {
        return {
            restrict: 'EA', // Restricts the directive to elements and attributes.
            replace: true, // Replaces the HTML element with the template.
            scope: {
                theKey: '=key', // Two-way binding for the key.
                prefData: '=data', // Two-way binding for preference data.
                parentScope: '=scope' // Two-way binding for parent scope.
            },
            templateUrl: "/views/ib/contentobjects/helpers/cms-preference-select.html", // URL of the template to be used.
            controller: ['$injector', '$scope', '$rootScope', '$signals', '$interval', class {
                /**
                 * Constructs the controller for the directive.
                 * @param {object} $injector - AngularJS injector service.
                 * @param {object} $scope - AngularJS scope for the directive.
                 * @param {object} $rootScope - AngularJS root scope.
                 * @param {object} $signals - Signals service for communication.
                 * @param {object} $interval - AngularJS interval service.
                 */
                constructor($injector, $scope, $rootScope, $signals, $interval) {
                    $scope.data = $scope.prefData[$scope.theKey]; // Initializes the data from preference data using the key.
                    $scope.randomId = angular.createUUID(); // Generates a random UUID for the scope.
                }
            }]
        };
    });
}